// frontend/src/utils/teamUtils.js

import teamsManifest from '../data/teamsManifest.json';

// Slugs of files that actually exist in public/teams/ (without extension).
// Regenerate after adding/removing logos:
//   cd frontend/public/teams && ls *.png | sed 's/\.png$//' | sort > manifest
const TEAM_FILES = new Set(teamsManifest);

// TEAM_DATA теперь является единым источником правды для информации о командах.
// Каждая запись содержит сокращение и название файла логотипа.
const TEAM_DATA = {
  // Популярные команды с длинными названиями
  'Paris Saint Germain': { abbreviation: 'PSG', logo: 'PSG' },
  'Paris Saint-Germain': { abbreviation: 'PSG', logo: 'PSG' },
  'Internazionale Milano': { abbreviation: 'Inter', logo: 'inter-milan' },
  'Inter Milan': { abbreviation: 'Inter', logo: 'inter-milan' },
  'Borussia Dortmund': { abbreviation: 'Dortmund', logo: 'Dortmund' },
  'Borussia Monchengladbach': { abbreviation: 'Gladbach', logo: 'Monchengladbach' },
  'Manchester United': { abbreviation: 'Man United', logo: 'manchester-united' },
  'Manchester City': { abbreviation: 'Man City', logo: 'man-city' },
  'Atletico Madrid': { abbreviation: 'Atletico', logo: 'atletico-madrid' },
  'Atlético Madrid': { abbreviation: 'Atletico Madrid', logo: 'atletico-madrid' },
  'Bayern Munich': { abbreviation: 'Bayern', logo: 'bayern-munich' },
  'Tottenham Hotspur': { abbreviation: 'Tottenham', logo: 'Tottenham' },
  'Leicester City': { abbreviation: 'Leicester', logo: 'Leicester' },
  'Brighton & Hove Albion': { abbreviation: 'Brighton', logo: 'Brighton' },
  'Crystal Palace': { abbreviation: 'Palace', logo: 'crystal-palace' },
  'Sheffield United': { abbreviation: 'Sheffield Utd', logo: 'Sheffield Utd' },
  'West Ham United': { abbreviation: 'West Ham', logo: 'west-ham' },
  'Newcastle United': { abbreviation: 'Newcastle', logo: 'Newcastle' },
  'Aston Villa': { abbreviation: 'Villa', logo: 'aston-villa' },
  'Wolverhampton Wanderers': { abbreviation: 'Wolves', logo: 'Wolves' },
  'Norwich City': { abbreviation: 'Norwich', logo: 'Norwich' },
  'Burnley': { abbreviation: 'Burnley', logo: 'Burnley' },
  'Watford': { abbreviation: 'Watford', logo: 'Watford' },
  'Southampton': { abbreviation: 'Southampton', logo: 'Southampton' },
  'Everton': { abbreviation: 'Everton', logo: 'Everton' },
  'Liverpool': { abbreviation: 'Liverpool', logo: 'Liverpool' },
  'Arsenal': { abbreviation: 'Arsenal', logo: 'Arsenal' },
  'Chelsea': { abbreviation: 'Chelsea', logo: 'Chelsea' },
  'Fulham': { abbreviation: 'Fulham', logo: 'Fulham' },
  'Brighton and Hove Albion': { abbreviation: 'Brighton', logo: 'Brighton' },
  'Bayer Leverkusen': { abbreviation: 'Leverkusen', logo: 'bayer-leverkusen' },
  'RB Leipzig': { abbreviation: 'Leipzig', logo: 'rb-leipzig' },
  'SC Freiburg': { abbreviation: 'Freiburg', logo: 'Freiburg' },
  'TSG Hoffenheim': { abbreviation: 'Hoffenheim', logo: 'Hoffenheim' },
  '1. FSV Mainz 05': { abbreviation: 'Mainz', logo: 'Mainz' },
  'VfL Wolfsburg': { abbreviation: 'Wolfsburg', logo: 'Wolfsburg' },
  'VfL Bochum': { abbreviation: 'Bochum', logo: 'Bochum' },
  'FC Augsburg': { abbreviation: 'Augsburg', logo: 'Augsburg' },
  '1. FC Union Berlin': { abbreviation: 'Union Berlin', logo: 'union-berlin' },
  '1. FC Heidenheim': { abbreviation: 'Heidenheim', logo: 'Heidenheim' },
  'Holstein Kiel': { abbreviation: 'Holstein Kiel', logo: 'holstein-kiel' },
  'FC St. Pauli': { abbreviation: 'St. Pauli', logo: 'st-pauli' },
  'VfB Stuttgart': { abbreviation: 'Stuttgart', logo: 'Stuttgart' },
  'Eintracht Frankfurt': { abbreviation: 'Eintracht', logo: 'eintracht-frankfurt' },
  'Celta Vigo': { abbreviation: 'Celta', logo: 'Celta' },
  'Athletic Club': { abbreviation: 'Athletic', logo: 'athletic-club' },
  'Alavés': { abbreviation: 'Alaves', logo: 'Alaves' },
  'Getafe CF': { abbreviation: 'Getafe', logo: 'Getafe' },
  'Girona FC': { abbreviation: 'Girona', logo: 'Girona' },
  'Rayo Vallecano': { abbreviation: 'Rayo Vallecano', logo: 'rayo-vallecano' },
  'Real Betis Balompié': { abbreviation: 'Real Betis', logo: 'real-betis' },
  'Real Sociedad de Fútbol': { abbreviation: 'Real Sociedad', logo: 'real-sociedad' },
  'Sevilla FC': { abbreviation: 'Sevilla', logo: 'Sevilla' },
  'Valencia CF': { abbreviation: 'Valencia', logo: 'Valencia' },
  'Villarreal CF': { abbreviation: 'Villarreal', logo: 'Villarreal' },
  'CA Osasuna': { abbreviation: 'Osasuna', logo: 'Osasuna' },
  'RCD Mallorca': { abbreviation: 'Mallorca', logo: 'Mallorca' },
  'UD Las Palmas': { abbreviation: 'Las Palmas', logo: 'las-palmas' },
  'CD Leganés': { abbreviation: 'Leganes', logo: 'Leganes' },
  'Cádiz CF': { abbreviation: 'Cadiz', logo: 'Cadiz' },
  'Granada CF': { abbreviation: 'Granada', logo: 'Granada' },
  'Levante UD': { abbreviation: 'Levante', logo: 'Levante' },
  'Real Valladolid': { abbreviation: 'Valladolid', logo: 'real-valladolid' },
  'Espanyol': { abbreviation: 'Espanyol', logo: 'Espanyol' },
  'AC Milan': { abbreviation: 'AC Milan', logo: 'ac-milan' },
  'Atalanta BC': { abbreviation: 'Atalanta', logo: 'Atalanta' },
  'Bologna FC 1909': { abbreviation: 'Bologna', logo: 'Bologna' },
  'Cagliari Calcio': { abbreviation: 'Cagliari', logo: 'Cagliari' },
  'Como 1907': { abbreviation: 'Como', logo: 'Como' },
  'Empoli FC': { abbreviation: 'Empoli', logo: 'Empoli' },
  'ACF Fiorentina': { abbreviation: 'Fiorentina', logo: 'Fiorentina' },
  'Genoa CFC': { abbreviation: 'Genoa', logo: 'Genoa' },
  'Hellas Verona FC': { abbreviation: 'Verona', logo: 'Verona' },
  'Juventus FC': { abbreviation: 'Juventus', logo: 'Juventus' },
  'SS Lazio': { abbreviation: 'Lazio', logo: 'Lazio' },
  'US Lecce': { abbreviation: 'Lecce', logo: 'Lecce' },
  'AC Monza': { abbreviation: 'Monza', logo: 'Monza' },
  'SSC Napoli': { abbreviation: 'Napoli', logo: 'Napoli' },
  'Parma Calcio 1913': { abbreviation: 'Parma', logo: 'Parma' },
  'AS Roma': { abbreviation: 'Roma', logo: 'Roma' },
  'Torino FC': { abbreviation: 'Torino', logo: 'Torino' },
  'Udinese Calcio': { abbreviation: 'Udinese', logo: 'Udinese' },
  'Venezia FC': { abbreviation: 'Venezia', logo: 'Venezia' },
  'AJ Auxerre': { abbreviation: 'Auxerre', logo: 'Auxerre' },
  'Angers SCO': { abbreviation: 'Angers', logo: 'Angers' },
  'Stade Brestois 29': { abbreviation: 'Brest', logo: 'Brest' },
  'Le Havre AC': { abbreviation: 'Le Havre', logo: 'le-havre' },
  'RC Lens': { abbreviation: 'Lens', logo: 'Lens' },
  'LOSC Lille': { abbreviation: 'Lille', logo: 'Lille' },
  'Olympique Lyonnais': { abbreviation: 'Lyon', logo: 'Lyon' },
  'Olympique de Marseille': { abbreviation: 'Marseille', logo: 'Marseille' },
  'FC Metz': { abbreviation: 'Metz', logo: 'Metz' },
  'AS Monaco FC': { abbreviation: 'Monaco', logo: 'Monaco' },
  'Montpellier HSC': { abbreviation: 'Montpellier', logo: 'Montpellier' },
  'FC Nantes': { abbreviation: 'Nantes', logo: 'Nantes' },
  'OGC Nice': { abbreviation: 'Nice', logo: 'Nice' },
  'Stade de Reims': { abbreviation: 'Reims', logo: 'Reims' },
  'Stade Rennais FC': { abbreviation: 'Rennes', logo: 'Rennes' },
  'AS Saint-Étienne': { abbreviation: 'Saint-Étienne', logo: 'saint-etienne' },
  'RC Strasbourg Alsace': { abbreviation: 'Strasbourg', logo: 'Strasbourg' },
  'Toulouse FC': { abbreviation: 'Toulouse', logo: 'Toulouse' },
  'USL Dunkerque': { abbreviation: 'Dunkerque', logo: 'Dunkerque' },
  'PSV Eindhoven': { abbreviation: 'PSV', logo: 'PSV' },
  'FC Twente': { abbreviation: 'Twente', logo: 'Twente' },
  'FC Utrecht': { abbreviation: 'Utrecht', logo: 'Utrecht' },
  'FC Groningen': { abbreviation: 'Groningen', logo: 'Groningen' },
  'FC Eindhoven': { abbreviation: 'Eindhoven', logo: 'Eindhoven' },
  'FC Den Bosch': { abbreviation: 'Den Bosch', logo: 'Den Bosch' },
  'FC Dordrecht': { abbreviation: 'Dordrecht', logo: 'Dordrecht' },
  'FC Volendam': { abbreviation: 'Volendam', logo: 'Volendam' },
  'FC Zwolle': { abbreviation: 'Zwolle', logo: 'Zwolle' },
  'FC Emmen': { abbreviation: 'Emmen', logo: 'Emmen' },
  'AVS Futebol SAD': { abbreviation: 'AFS', logo: 'AFS' },
  'Porto': { abbreviation: 'Porto', logo: 'fc-porto' },
  'FC Porto': { abbreviation: 'Porto', logo: 'fc-porto' },
  'FC Braga': { abbreviation: 'Braga', logo: 'Braga' },
  'FC Lisbon': { abbreviation: 'Lisbon', logo: 'Lisbon' },
  'NAC Breda': { abbreviation: 'Breda', logo: 'Breda' },
  'West Bromwich Albion': { abbreviation: 'West Brom', logo: 'west-brom' },
  'Blackburn Rovers': { abbreviation: 'Blackburn', logo: 'Blackburn' },
  'Panathinaikos': { abbreviation: 'Panathinaikos' , logo: 'Panathinaikos' },
  'Young Boys': { logo: 'young-boys' },
  'Werder Bremen': { logo: 'werder-bremen' },
  'Willem II': { logo: 'willem-ii' },
  'West Brom': { abbreviation: 'West Brom', logo: 'west-brom' },
  'Western Sydney': { logo: 'western-sydney' },
  'Wellington Phoenix': { logo: 'wellington-phoenix' },
  'Vancouver Whitecaps': { logo: 'vancouver-whitecaps' },
  'Vasco Da Gama': { logo: 'vasco-da-gama' },
  'Viktoria Plzeň': { logo: 'viktoria-plzen' },
  'Zorya Lugansk': { logo: 'zorya-lugansk' },
  'Zarya Lugansk': { logo: 'zarya-lugansk' },
  'Athletic Bilbao': { logo: 'athletic-bilbao' },
  'Real Madrid': { logo: 'real-madrid' },
  'Barcelona': { logo: 'Barcelona' },
  'Borussia Mönchengladbach': { logo: 'Monchengladbach' },
  'Hertha Berlin': { logo: 'hertha-berlin' },
  '1. FC Köln': { abbreviation: 'Köln', logo: 'koln' },
 
  // --- Добавлено: альтернативные лиги ---
  // Eredivisie
  'AFC Ajax': { abbreviation: 'Ajax', logo: 'Ajax' },
  'FC Midtjylland': { abbreviation: 'Midtjylland', logo: 'Midtjylland' },
  'Feyenoord': { abbreviation: 'Feyenoord', logo: 'Feyenoord' },
  'AZ Alkmaar': { abbreviation: 'AZ', logo: 'az-alkmaar' },
  'SC Heerenveen': { abbreviation: 'Heerenveen', logo: 'Heerenveen' },
  'Vitesse': { abbreviation: 'Vitesse', logo: 'Vitesse' },
  'NEC Nijmegen': { abbreviation: 'NEC', logo: 'NEC' },
  'Sparta Rotterdam': { abbreviation: 'Sparta', logo: 'Sparta' },
  'RKC Waalwijk': { abbreviation: 'RKC', logo: 'RKC' },
  'Heracles Almelo': { abbreviation: 'Heracles', logo: 'Heracles' },
  'Go Ahead Eagles': { abbreviation: 'Go Ahead', logo: 'go-ahead' },
  'Fortuna Sittard': { abbreviation: 'Fortuna', logo: 'Fortuna' },
  'PEC Zwolle': { abbreviation: 'Zwolle', logo: 'Zwolle' },
  'Almere City FC': { abbreviation: 'Almere City', logo: 'almere-city' },
  'SBV Excelsior': { abbreviation: 'Excelsior', logo: 'excelsior' },
  'ADO Den Haag': { abbreviation: 'Den Haag', logo: 'den-haag' },
  'SC Cambuur': { abbreviation: 'Cambuur', logo: 'cambuur' },
  'De Graafschap': { abbreviation: 'Graafschap', logo: 'de-graafschap' },
  'KRC Genk': { abbreviation: 'Genk', logo: 'Genk' },

  // EFL Championship
  'Leeds United': { abbreviation: 'Leeds', logo: 'Leeds' },
  'Ipswich Town': { abbreviation: 'Ipswich', logo: 'ipswich-town' },
  'Middlesbrough': { abbreviation: 'Middlesbrough', logo: 'middlesbrough' },
  'Sunderland': { abbreviation: 'Sunderland', logo: 'Sunderland' },
  'Stoke City': { abbreviation: 'Stoke', logo: 'stoke-city' },
  'Swansea City': { abbreviation: 'Swansea', logo: 'swansea-city' },
  'Coventry City': { abbreviation: 'Coventry', logo: 'coventry-city' },
  'Hull City': { abbreviation: 'Hull', logo: 'hull-city' },
  'Bristol City': { abbreviation: 'Bristol City', logo: 'bristol-city' },
  'Cardiff City': { abbreviation: 'Cardiff', logo: 'cardiff-city' },
  'Queens Park Rangers': { abbreviation: 'QPR', logo: 'queens-park-rangers' },
  'Plymouth Argyle': { abbreviation: 'Plymouth', logo: 'plymouth-argyle' },
  'Rotherham United': { abbreviation: 'Rotherham', logo: 'rotherham-united' },
  'Sheffield Wednesday': { abbreviation: 'Sheff Wed', logo: 'sheffield-wednesday' },
  'Preston North End': { abbreviation: 'Preston', logo: 'preston' },
  'Millwall': { abbreviation: 'Millwall', logo: 'Millwall' },
  'Huddersfield Town': { abbreviation: 'Huddersfield', logo: 'huddersfield-town' },
  'Birmingham City': { abbreviation: 'Birmingham', logo: 'birmingham-city' },

  // Portugal Primeira Liga
  'SL Benfica': { abbreviation: 'Benfica', logo: 'Benfica' },
  'Sporting CP': { abbreviation: 'Sporting', logo: 'sporting' },
  'Sporting Lisbon': { abbreviation: 'Sporting', logo: 'sporting' },
  'Vitória SC': { abbreviation: 'Vitoria', logo: 'vitoria-sc' },
  'Vitoria Guimaraes': { abbreviation: 'Vitoria', logo: 'vitoria-sc' },
  'Boavista FC': { abbreviation: 'Boavista', logo: 'Boavista' },
  'Rio Ave FC': { abbreviation: 'Rio Ave', logo: 'rio-ave' },
  'FC Famalicão': { abbreviation: 'Famalicao', logo: 'famalicao' },
  'GD Chaves': { abbreviation: 'Chaves', logo: 'Chaves' },
  'FC Arouca': { abbreviation: 'Arouca', logo: 'Arouca' },
  'Portimonense SC': { abbreviation: 'Portimonense', logo: 'portimonense' },
  'Gil Vicente FC': { abbreviation: 'Gil Vicente', logo: 'gil-vicente' },
  'Estoril Praia': { abbreviation: 'Estoril', logo: 'Estoril' },
  'FC Vizela': { abbreviation: 'Vizela', logo: 'Vizela' },
  'Casa Pia AC': { abbreviation: 'Casa Pia', logo: 'casa-pia' },
  'SC Farense': { abbreviation: 'Farense', logo: 'Farense' },
  'Estrela Amadora': { abbreviation: 'Estrela', logo: 'estrela-amadora' },
  'Moreirense FC': { abbreviation: 'Moreirense', logo: 'Moreirense' },

  // Ireland Premier Division
  'Shamrock Rovers': { abbreviation: 'Shamrock', logo: 'shamrock-rovers' },
  "St Patrick's Athletic": { abbreviation: "St Pat's", logo: 'st-patricks-athletic' },
  'Bohemians': { abbreviation: 'Bohemians', logo: 'Bohemians' },
  'Sligo Rovers': { abbreviation: 'Sligo', logo: 'sligo-rovers' },
  'Shelbourne': { abbreviation: 'Shelbourne', logo: 'Shelbourne' },
  'Waterford': { abbreviation: 'Waterford', logo: 'Waterford' },
  'Drogheda United': { abbreviation: 'Drogheda', logo: 'drogheda-united' },
  'Galway United': { abbreviation: 'Galway', logo: 'galway-united' },

  // Coppa Italia (дополнительно)
  'Frosinone': { abbreviation: 'Frosinone', logo: 'Frosinone' },
  'Sassuolo': { abbreviation: 'Sassuolo', logo: 'Sassuolo' },
  'Spezia': { abbreviation: 'Spezia', logo: 'Spezia' },
  'Cremonese': { abbreviation: 'Cremonese', logo: 'Cremonese' },
  'Salernitana': { abbreviation: 'Salernitana', logo: 'Salernitana' },
  'Brescia': { abbreviation: 'Brescia', logo: 'Brescia' },
  'Catania': { abbreviation: 'Catania', logo: 'Catania' },
  'Bari': { abbreviation: 'Bari', logo: 'Bari' },
  'Palermo': { abbreviation: 'Palermo', logo: 'Palermo' },

  // --- National Teams (World Cup 2026, Euro, Nations League) ---
  // Europe
  'Albania': { abbreviation: 'ALB', logo: 'Albania' },
  'Andorra': { abbreviation: 'AND', logo: 'Andorra' },
  'Armenia': { abbreviation: 'ARM', logo: 'Armenia' },
  'Austria': { abbreviation: 'AUT', logo: 'Austria' },
  'Azerbaijan': { abbreviation: 'AZE', logo: 'Azerbaijan' },
  'Belarus': { abbreviation: 'BLR', logo: 'Belarus' },
  'Belgium': { abbreviation: 'BEL', logo: 'Belgium' },
  'Bosnia and Herzegovina': { abbreviation: 'BIH', logo: 'bosnia-herzegovina' },
  'Bosnia-Herzegovina': { abbreviation: 'BIH', logo: 'bosnia-herzegovina' },
  'Bulgaria': { abbreviation: 'BUL', logo: 'Bulgaria' },
  'Croatia': { abbreviation: 'CRO', logo: 'Croatia' },
  'Cyprus': { abbreviation: 'CYP', logo: 'Cyprus' },
  'Czech Republic': { abbreviation: 'CZE', logo: 'czech-republic' },
  'Czechia': { abbreviation: 'CZE', logo: 'czech-republic' },
  'Denmark': { abbreviation: 'DEN', logo: 'Denmark' },
  'England': { abbreviation: 'ENG', logo: 'England' },
  'Estonia': { abbreviation: 'EST', logo: 'Estonia' },
  'Faroe Islands': { abbreviation: 'FRO', logo: 'faroe-islands' },
  'Finland': { abbreviation: 'FIN', logo: 'Finland' },
  'France': { abbreviation: 'FRA', logo: 'France' },
  'Georgia': { abbreviation: 'GEO', logo: 'Georgia' },
  'Germany': { abbreviation: 'GER', logo: 'Germany' },
  'Gibraltar': { abbreviation: 'GIB', logo: 'Gibraltar' },
  'Greece': { abbreviation: 'GRE', logo: 'Greece' },
  'Hungary': { abbreviation: 'HUN', logo: 'Hungary' },
  'Iceland': { abbreviation: 'ISL', logo: 'Iceland' },
  'Ireland': { abbreviation: 'IRL', logo: 'Ireland' },
  'Republic of Ireland': { abbreviation: 'IRL', logo: 'Ireland' },
  'Israel': { abbreviation: 'ISR', logo: 'Israel' },
  'Italy': { abbreviation: 'ITA', logo: 'Italy' },
  'Kazakhstan': { abbreviation: 'KAZ', logo: 'Kazakhstan' },
  'Kosovo': { abbreviation: 'KOS', logo: 'Kosovo' },
  'Latvia': { abbreviation: 'LAT', logo: 'Latvia' },
  'Liechtenstein': { abbreviation: 'LIE', logo: 'Liechtenstein' },
  'Lithuania': { abbreviation: 'LTU', logo: 'Lithuania' },
  'Luxembourg': { abbreviation: 'LUX', logo: 'Luxembourg' },
  'Malta': { abbreviation: 'MLT', logo: 'Malta' },
  'Moldova': { abbreviation: 'MDA', logo: 'Moldova' },
  'Montenegro': { abbreviation: 'MNE', logo: 'Montenegro' },
  'Netherlands': { abbreviation: 'NED', logo: 'Netherlands' },
  'North Macedonia': { abbreviation: 'MKD', logo: 'north-macedonia' },
  'Northern Ireland': { abbreviation: 'NIR', logo: 'northern-ireland' },
  'Norway': { abbreviation: 'NOR', logo: 'Norway' },
  'Poland': { abbreviation: 'POL', logo: 'Poland' },
  'Portugal': { abbreviation: 'POR', logo: 'Portugal' },
  'Romania': { abbreviation: 'ROU', logo: 'Romania' },
  'Russia': { abbreviation: 'RUS', logo: 'Russia' },
  'Scotland': { abbreviation: 'SCO', logo: 'Scotland' },
  'Serbia': { abbreviation: 'SRB', logo: 'Serbia' },
  'Slovakia': { abbreviation: 'SVK', logo: 'Slovakia' },
  'Slovenia': { abbreviation: 'SVN', logo: 'Slovenia' },
  'Spain': { abbreviation: 'ESP', logo: 'Spain' },
  'Sweden': { abbreviation: 'SWE', logo: 'Sweden' },
  'Switzerland': { abbreviation: 'SUI', logo: 'Switzerland' },
  'Turkey': { abbreviation: 'TUR', logo: 'Turkey' },
  'Ukraine': { abbreviation: 'UKR', logo: 'Ukraine' },
  'Wales': { abbreviation: 'WAL', logo: 'Wales' },

  // South America
  'Argentina': { abbreviation: 'ARG', logo: 'Argentina' },
  'Bolivia': { abbreviation: 'BOL', logo: 'Bolivia' },
  'Brazil': { abbreviation: 'BRA', logo: 'Brazil' },
  'Chile': { abbreviation: 'CHI', logo: 'Chile' },
  'Colombia': { abbreviation: 'COL', logo: 'Colombia' },
  'Ecuador': { abbreviation: 'ECU', logo: 'Ecuador' },
  'Paraguay': { abbreviation: 'PAR', logo: 'Paraguay' },
  'Peru': { abbreviation: 'PER', logo: 'Peru' },
  'Uruguay': { abbreviation: 'URU', logo: 'Uruguay' },
  'Venezuela': { abbreviation: 'VEN', logo: 'Venezuela' },

  // North/Central America & Caribbean
  'Mexico': { abbreviation: 'MEX', logo: 'Mexico' },
  'USA': { abbreviation: 'USA', logo: 'USA' },
  'United States': { abbreviation: 'USA', logo: 'USA' },
  'Jamaica': { abbreviation: 'JAM', logo: 'Jamaica' },
  'Canada': { abbreviation: 'CAN', logo: 'Canada' },
  'Costa Rica': { abbreviation: 'CRC', logo: 'costa-rica' },
  'Honduras': { abbreviation: 'HON', logo: 'Honduras' },
  'Panama': { abbreviation: 'PAN', logo: 'Panama' },
  'Curacao': { abbreviation: 'CUW', logo: 'Curacao' },
  'Curaçao': { abbreviation: 'CUW', logo: 'Curacao' },

  // Africa
  'Algeria': { abbreviation: 'ALG', logo: 'Algeria' },
  'Angola': { abbreviation: 'ANG', logo: 'Angola' },
  'Benin': { abbreviation: 'BEN', logo: 'Benin' },
  'Burkina Faso': { abbreviation: 'BFA', logo: 'burkina-faso' },
  'Burundi': { abbreviation: 'BDI', logo: 'Burundi' },
  'Cameroon': { abbreviation: 'CMR', logo: 'Cameroon' },
  'Congo': { abbreviation: 'CGO', logo: 'Congo' },
  'DR Congo': { abbreviation: 'COD', logo: 'dr-congo' },
  'Cape Verde': { abbreviation: 'CPV', logo: 'cape-verde' },
  'Egypt': { abbreviation: 'EGY', logo: 'Egypt' },
  'Ghana': { abbreviation: 'GHA', logo: 'Ghana' },
  'Guinea': { abbreviation: 'GUI', logo: 'Guinea' },
  'Guinea-Bissau': { abbreviation: 'GNB', logo: 'guinea-bissau' },
  'Ivory Coast': { abbreviation: 'CIV', logo: 'ivory-coast' },
  'Kenya': { abbreviation: 'KEN', logo: 'Kenya' },
  'Madagascar': { abbreviation: 'MAD', logo: 'Madagascar' },
  'Mali': { abbreviation: 'MLI', logo: 'Mali' },
  'Mauritania': { abbreviation: 'MTN', logo: 'Mauritania' },
  'Morocco': { abbreviation: 'MAR', logo: 'Morocco' },
  'Namibia': { abbreviation: 'NAM', logo: 'Namibia' },
  'Nigeria': { abbreviation: 'NGA', logo: 'Nigeria' },
  'Senegal': { abbreviation: 'SEN', logo: 'Senegal' },
  'South Africa': { abbreviation: 'RSA', logo: 'south-africa' },
  'Tanzania': { abbreviation: 'TAN', logo: 'Tanzania' },
  'Tunisia': { abbreviation: 'TUN', logo: 'Tunisia' },
  'Uganda': { abbreviation: 'UGA', logo: 'Uganda' },
  'Zimbabwe': { abbreviation: 'ZIM', logo: 'Zimbabwe' },

  // Asia & Oceania
  'China': { abbreviation: 'CHN', logo: 'China' },
  'Haiti': { abbreviation: 'HAI', logo: 'Haiti' },
  'Japan': { abbreviation: 'JPN', logo: 'Japan' },
  'Qatar': { abbreviation: 'QAT', logo: 'Qatar' },
  'Australia': { abbreviation: 'AUS', logo: 'Australia' },
  'Saudi Arabia': { abbreviation: 'KSA', logo: 'saudi-arabia' },
  'South Korea': { abbreviation: 'KOR', logo: 'south-korea' },
  'Iran': { abbreviation: 'IRN', logo: 'Iran' },
  'Iraq': { abbreviation: 'IRQ', logo: 'Iraq' },
  'Jordan': { abbreviation: 'JOR', logo: 'Jordan' },
  'Uzbekistan': { abbreviation: 'UZB', logo: 'Uzbekistan' },
  'India': { abbreviation: 'IND', logo: 'India' },
  'New Zealand': { abbreviation: 'NZL', logo: 'new-zealand' },
  'Indonesia': { abbreviation: 'IDN', logo: 'Indonesia' },
};

/**
 * Нормализует название команды, удаляя общие префиксы/суффиксы и приводя к нижнему регистру.
 * @param {string} teamName - Название команды
 * @returns {string} - Нормализованное название
 */
const normalizeTeamName = (teamName) => {
  if (!teamName || typeof teamName !== 'string') return '';
  
  return teamName
    .toLowerCase()
    // Удаляем распространенные футбольные аббревиатуры (как отдельные слова)
    .replace(/\b(fc|cf|sc|ac|rc|cd|ud|as|ss|ssc|1\.?|afc|hsc|bc|fk|if|ilk|scf|sk|srl|sv|tsg|vfl|vfb|gfc|fc|cdb)\b/g, '')
    // Удаляем числа, которые часто бывают в конце (e.g., Bologna FC 1909)
    .replace(/\s+\d+$/, '')
    // Заменяем специальные символы и диакритические знаки на их аналоги
    .replace(/ & /g, ' and ')
    .replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/é/g, 'e').replace(/á/g, 'a')
    // Удаляем все оставшиеся не-буквенно-цифровые символы, кроме дефисов
    .replace(/[^a-z\s-]/g, '')
    // Удаляем слова-артикли, которые могут отличаться
    .replace(/\b(de|da|el)\b/g, '')
    // Убираем лишние пробелы
    .replace(/\s+/g, ' ')
    .trim();
};

/** Weights per tier for top-match toast scoring (see topMatchScoring). Sync with backend/config/matchPriority.js. */
const TEAM_SPOTLIGHT_WEIGHT_TIER1 = 60;
const TEAM_SPOTLIGHT_WEIGHT_TIER2 = 45;

/**
 * Tier-1: global top draws (consistent UCL contenders).
 * Multiple display variants per entity so normalizeTeamName aligns with API strings.
 */
const ELITE_SPOTLIGHT_TIER1 = [
  'Real Madrid',
  'Barcelona',
  'Liverpool',
  'Bayern Munich',
  'Manchester City',
  'Manchester United',
  'Chelsea',
  'Arsenal',
  'Paris Saint Germain',
  'Paris Saint-Germain',
  'Internazionale Milano',
  'Inter Milan',
  'Juventus',
  'AC Milan',
];

/**
 * Tier-2: strong clubs and top national teams — not every TEAM_DATA entry (mid-table clubs stay 0).
 */
const ELITE_SPOTLIGHT_TIER2 = [
  'Tottenham Hotspur',
  'SSC Napoli',
  'AS Roma',
  'Borussia Dortmund',
  'Atlético Madrid',
  'Atletico Madrid',
  'RB Leipzig',
  'Bayer Leverkusen',
  'Newcastle United',
  'Aston Villa',
  'West Ham United',
  'Sevilla FC',
  'Villarreal CF',
  'Real Sociedad',
  'Athletic Club',
  'Benfica',
  'Porto',
  'Sporting CP',
  'Sporting Lisbon',
  'AFC Ajax',
  'PSV Eindhoven',
  'AS Monaco FC',
  'Marseille',
  'Lyon',
  'Spain',
  'France',
  'Germany',
  'Portugal',
  'Italy',
  'England',
  'Brazil',
  'Argentina',
  'Netherlands',
  'Belgium',
  'Croatia',
  'Uruguay',
  'Poland',
  'United States',
  'Mexico',
  'Japan',
  'South Korea'
];

const ELITE_SPOTLIGHT_TIER1_NORMALIZED = new Set(
  ELITE_SPOTLIGHT_TIER1.map((n) => normalizeTeamName(n)).filter(Boolean)
);
const ELITE_SPOTLIGHT_TIER2_NORMALIZED = new Set(
  ELITE_SPOTLIGHT_TIER2.map((n) => normalizeTeamName(n)).filter(Boolean)
);

// Создаем предварительно вычисленные нормализованные карты для производительности
const createNormalizedMap = (originalMap) => {
  const normalizedMap = {};
  for (const key in originalMap) {
    const normalizedKey = normalizeTeamName(key);
    // Сохраняем только если нормализованный ключ не пустой
    if (normalizedKey) {
      // Если для одного нормализованного ключа уже есть значение, не перезаписываем,
      // чтобы избежать случайных коллизий. Первый встреченный вариант - главный.
      if (!normalizedMap[normalizedKey]) {
        normalizedMap[normalizedKey] = originalMap[key];
      }
    }
  }
  return normalizedMap;
};

const NORMALIZED_TEAM_DATA = createNormalizedMap(TEAM_DATA);

/**
 * Получает сокращенное название команды для мобильных устройств
 * @param {string} teamName - Полное название команды
 * @returns {string} - Сокращенное название или оригинальное
 */
export const getTeamAbbreviation = (teamName) => {
  if (!teamName) return '';

  // 1. Прямое совпадение (самый быстрый вариант)
  const directMatch = TEAM_DATA[teamName]?.abbreviation;
  if (directMatch) return directMatch;
  
  // 2. Совпадение по нормализованному названию
  const normalizedName = normalizeTeamName(teamName);
  const normalizedMatch = NORMALIZED_TEAM_DATA[normalizedName]?.abbreviation;
  if (normalizedMatch) return normalizedMatch;

  // 3. Возвращаем оригинальное имя, если ничего не найдено
  return teamName;
};

/**
 * Spotlight weight for top-match selection (0 = not in elite curated set).
 * @param {string | undefined} teamName
 * @returns {number}
 */
export const getTeamSpotlightWeight = (teamName) => {
  if (!teamName || typeof teamName !== 'string') return 0;
  const key = normalizeTeamName(teamName);
  if (!key) return 0;
  if (ELITE_SPOTLIGHT_TIER1_NORMALIZED.has(key)) return TEAM_SPOTLIGHT_WEIGHT_TIER1;
  if (ELITE_SPOTLIGHT_TIER2_NORMALIZED.has(key)) return TEAM_SPOTLIGHT_WEIGHT_TIER2;
  return 0;
};

/**
 * Known country names for automatic national team detection.
 * If teamName matches, getTeamLogoPaths adds a direct path with high priority.
 */
const KNOWN_COUNTRIES = new Set([
  'Albania', 'Algeria', 'Andorra', 'Angola', 'Argentina', 'Armenia', 'Australia',
  'Austria', 'Azerbaijan', 'Belarus', 'Belgium', 'Benin', 'Bolivia', 'Brazil',
  'Bulgaria', 'Burkina Faso', 'Burundi', 'Cameroon', 'Canada', 'Cape Verde', 'Chile', 'China',
  'Colombia', 'Congo', 'Costa Rica', 'Croatia', 'Curacao', 'Curaçao', 'Cyprus', 'Czech Republic', 'Czechia',
  'Denmark', 'DR Congo', 'Ecuador', 'Egypt', 'England', 'Estonia', 'Finland', 'France',
  'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Guinea', 'Haiti',
  'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland',
  'Israel', 'Italy', 'Ivory Coast', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya',
  'Kosovo', 'Latvia', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar',
  'Mali', 'Malta', 'Mauritania', 'Mexico', 'Moldova', 'Montenegro', 'Morocco',
  'Namibia', 'Netherlands', 'New Zealand', 'Nigeria', 'North Macedonia',
  'Northern Ireland', 'Norway', 'Panama', 'Paraguay', 'Peru', 'Poland', 'Portugal',
  'Qatar', 'Romania', 'Russia', 'Saudi Arabia', 'Scotland', 'Senegal', 'Serbia',
  'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain', 'Sweden',
  'Switzerland', 'Tanzania', 'Tunisia', 'Turkey', 'USA', 'Uganda', 'Ukraine',
  'United States', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Wales', 'Zimbabwe',
]);

/**
 * Генерирует массив возможных путей к логотипу команды.
 * Возвращает пустой массив если ничего не нашлось — fallback рендерится в компоненте TeamLogo.
 * @param {string} teamName - Название команды
 * @returns {string[]} - Массив возможных путей (без default)
 */
export const getTeamLogoPaths = (teamName) => {
  if (!teamName || typeof teamName !== 'string') {
    return [];
  }

  const paths = new Set();

  // Add candidate only if the file exists in public/teams (avoids 404 waterfalls).
  // .webp first, .png as fallback (TeamLogo tries paths in order).
  const addPath = (pngPath) => {
    const slug = pngPath.replace(/^\/teams\//, '').replace(/\.png$/, '');
    if (!TEAM_FILES.has(slug)) return;
    paths.add(pngPath.replace(/\.png$/, '.webp'));
    paths.add(pngPath);
  };

  // 1. Direct TEAM_DATA mapping (highest priority)
  const directMappedInfo = TEAM_DATA[teamName];
  if (directMappedInfo?.logo) {
    addPath(`/teams/${directMappedInfo.logo}.png`);
  }

  // 2. Normalized mapping
  const normalizedName = normalizeTeamName(teamName);
  const normalizedMappedInfo = NORMALIZED_TEAM_DATA[normalizedName];
  if (normalizedMappedInfo?.logo) {
    addPath(`/teams/${normalizedMappedInfo.logo}.png`);
  }

  // 3. Country detection — try exact name and kebab-case
  if (KNOWN_COUNTRIES.has(teamName)) {
    addPath(`/teams/${teamName}.png`);
    addPath(`/teams/${teamName.toLowerCase().replace(/[\s]+/g, '-')}.png`);
  }

  const logoName = directMappedInfo?.logo || normalizedMappedInfo?.logo;
  const baseName = logoName || teamName;

  // 4. Kebab-case from best known name
  addPath(`/teams/${baseName.toLowerCase().replace(/[\s_]+/g, '-')}.png`);

  // 5. Original casing if different from kebab
  if (baseName.toLowerCase().replace(/[\s_]+/g, '-') !== baseName.toLowerCase()) {
    addPath(`/teams/${baseName}.png`);
  }

  // 6. First word heuristic (skip short/common prefixes)
  const firstWord = teamName.split(' ')[0];
  if (firstWord && firstWord.length > 3 && !/\b(fc|cf|sc|rc)\b/i.test(firstWord)) {
    addPath(`/teams/${firstWord}.png`);
  }

  return Array.from(paths);
}; 